import PenalidadesDadosGeraisUrlBuilder from '@/core/utils/factory/penalidades/dados-gerais/PenalidadesDadosGeraisUrlBuilder'
import PenalidadesItensUrlBuilder from '@/core/utils/factory/penalidades/itens/PenalidadesItensUrlBuilder'
import PenalidadesNotificacoesUrlBuilder from '@/core/utils/factory/penalidades/notificacoes/PenalidadesNotificacoesUrlBuilder'

class PenalidadesUrlBuilder {
	tipo

	constructor(tipo) {
		this.tipo = tipo
		this.dadosGerais = new PenalidadesDadosGeraisUrlBuilder(this.tipo)
		this.itens = new PenalidadesItensUrlBuilder(this.tipo)
		this.notificacoes = new PenalidadesNotificacoesUrlBuilder(this.tipo)
	}

	getUrlBuscaPaginada() {
		return `api/${this.tipo.path}/penalidades`
	}

	getUrlValidarPenalidade() {
		return `api/${this.tipo.path}/penalidades/validar`
	}

	getUrlExcluirPenalidade() {
		return `api/${this.tipo.path}/penalidades`
	}
}

export default PenalidadesUrlBuilder
